import React from "react";
import * as bie from "react-bootstrap";

export default function CommonFormHeading({ heading }) {
    return (
        <bie.Container fluid className="px-2 mb-3 common-heading-wrap mt-4">
            <bie.Row>
                <bie.Col xs={12}>
                    <div
                        style={{
                            display: "flex",
                            alignItems: "center",

                        }}
                    >
                        <span
                            className="left-brdh4"
                        >

                        </span>

                        <h4
                            className="inner-headerh4 mb-0"
                        >
                            {heading}
                        </h4>
                    </div>
                </bie.Col>
            </bie.Row>
        </bie.Container>
    );
}